import { Col, Container, Row, Stack } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { DynamicHtml } from "@/ui/DynamicHtml";
import { useLink } from "@/hooks/useLink";
import Logo from "@/assets/LogoDarkEN.svg";
import { getTeam } from "@/functions/getTeam";
import { useEffect, useState } from "react";
import { useMediaQuery } from "@react-hook/media-query";
import { Heading } from "@/ui/Heading";

export const AboutPageTeamSection = ({ className }) => {
  const [isMobile, setMobile] = useState(true);
  const md = useMediaQuery("only screen and (min-width: 768px)");
  const team = getTeam();
  const locale = useLocale();
  const link = useLink();

  useEffect(() => {
    setMobile(!md);
  }, [md]);

  return (
    <div className={className}>
      <Container>
        {isMobile && (
          <Heading className="mb-4">
            <DynamicText tag="h2" path={`page.team.subtitle.${locale}`} />
          </Heading>
        )}
        <Row>
          <Col xs={12} lg={4} className="mb-4 mb-lg-0">
            <div className={clsx(classes.intro, "p-4 p-md-5")}>
              {!isMobile && <DynamicText path={`page.team.subtitle.${locale}`} tag="h2" />}
              <DynamicText path={`page.team.title.${locale}`} tag="h3" className="mb-4" />
              <DynamicHtml path={`page.team.text.${locale}`} />
            </div>
          </Col>
          <Col xs={12} lg={8}>
            <Row>
              {team.slice(0, 3).map((i, k) => (
                <Col key={k} xs={12} sm={6} className={clsx(classes.card, "mb-4")}>
                  <a href={link(`team`, i.url_slug)}>
                    {i.photo ? (
                      <img src={i.photo} alt="" className="w-100" />
                    ) : (
                      <div className="ratio ratio-1x1 bg-white">
                        <div className="d-flex align-items-center p-5">
                          <Logo className="w-100" />
                        </div>
                      </div>
                    )}
                    <h4 className="h5" dangerouslySetInnerHTML={{ __html: i.name }} />
                    <dl className="mb-0">
                      <dd className="mb-0" dangerouslySetInnerHTML={{ __html: i[`position_${locale}`] }} />
                    </dl>
                  </a>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
